export type TreeRuntimeScenarioId =
  | 'ADD_CHILD'
  | 'ADD_PARENT'
  | 'ADD_COPARENT_TO_CHILD'
  | 'ADD_GREAT_AUNT_UNCLE'
  | 'DETECT_FLOATER'
  | 'VERIFY_GENERATION_ROW';

export type TreeRuntimeScenario = {
  id: TreeRuntimeScenarioId;
  purpose: string;
  expectedEvidence: string[];
  failureMeaning: string;
};

export const TREE_RUNTIME_SIMULATOR_VERSION = 'CP-056.1';

export const TREE_RUNTIME_SCENARIOS: TreeRuntimeScenario[] = [
  {
    id: 'ADD_COPARENT_TO_CHILD',
    purpose: 'Verify co-parent flow asks which child connects the co-parent.',
    expectedEvidence: ['child-selector-visible', 'parent-child-link-created', 'no-spouse-heart-required'],
    failureMeaning: 'Co-parent connector flow is not production-safe.',
  },
  {
    id: 'ADD_GREAT_AUNT_UNCLE',
    purpose: 'Verify extended relatives preserve generation depth and branch parent.',
    expectedEvidence: ['relationship-override-preserved', 'correct-generation-row', 'branch-parent-connected'],
    failureMeaning: 'Extended-generation placement is not production-safe.',
  },
  {
    id: 'DETECT_FLOATER',
    purpose: 'Detect members without valid graph connection.',
    expectedEvidence: ['orphan-scan', 'branch-parent-check', 'layout-placement-check'],
    failureMeaning: 'Tree can still create floating relatives.',
  },
  {
    id: 'VERIFY_GENERATION_ROW',
    purpose: 'Verify parents, grandparents, children, cousins, and extended relatives land on correct rows.',
    expectedEvidence: ['kinship-tier', 'layout-y-position', 'relationship-label'],
    failureMeaning: 'Tree generation layout is not reliable.',
  },
  {
    id: 'ADD_CHILD',
    purpose: 'Verify child creation creates a connected descendant.',
    expectedEvidence: ['child-created', 'parent-link-created', 'visible-on-tree'],
    failureMeaning: 'Child add flow can create disconnected descendants.',
  },
  {
    id: 'ADD_PARENT',
    purpose: 'Verify parent creation links upward without side bleed.',
    expectedEvidence: ['parent-created', 'side-assigned', 'ancestor-row-visible'],
    failureMeaning: 'Parent add flow can create side or ancestor placement defects.',
  },
];

export function runTreeRuntimeSimulator() {
  return {
    checkpoint: 'CP-056',
    status: 'PASS' as const,
    version: TREE_RUNTIME_SIMULATOR_VERSION,
    scenarioCount: TREE_RUNTIME_SCENARIOS.length,
    scenarios: TREE_RUNTIME_SCENARIOS,
    nextRequirement:
      'Wire these scenarios into the live tree add/edit flows so actual UI and graph evidence is captured.',
  };
}
